module.exports = __webpack_public_path__ + "static/media/16UNODC28.1d66e09b.jpg";